import "../styles/stepper.css";

const Stepper = ({ steps = [], activeStep = 0, setActiveStep, flag }) => {
  const handleStepClick = (index) => {
    setActiveStep(index);
  };
  return (
    <div className="container-fluid py-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10">
          <div className="d-flex justify-content-between align-items-center position-relative">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`stepper-item position-relative text-center flex-fill cursor-pointer ${
                  activeStep === index ? "active" : ""
                } ${activeStep > index ? "completed" : ""}`}
                onClick={() => {
                  flag === "edit" && handleStepClick(index);
                }}
              >
                <div className="stepper-number mx-auto">
                  {activeStep > index ? "✓" : index + 1}
                </div>
                <div className="stepper-label mt-2">{step}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
